import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HygieneReportRoutingModule } from './hygiene-report-routing.module';
import { HygineLinkComponent } from './hygine-link/hygine-link.component';
import { HygineLandingComponent } from './hygine-landing/hygine-landing.component';
import { HygineReportComponent } from './hygine-report/hygine-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { environment } from 'src/environments/environment';
import { HygineReportDialogComponent } from './hygine-report-dialog/hygine-report-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';


ModuleRegistry.registerModules([AllEnterpriseModule]);
 
LicenseManager.setLicenseKey(environment.ag_grid_key);

@NgModule({
  declarations: [
    HygineLinkComponent,
    HygineLandingComponent,
    HygineReportComponent,
    HygineReportDialogComponent
  ],
  imports: [
    CommonModule,
    AcademicFormModule,
    HygieneReportRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AgGridModule,
     MatDialogModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class HygieneReportModule { }
